// Korean translations (한국어)
import { TranslationKeys } from './en';

export const ko: TranslationKeys = {
  // Common
  common: {
    home: '홈',
    settings: '설정',
    language: '언어',
    loading: '로딩 중...',
    save: '저장',
    cancel: '취소',
    confirm: '확인',
    close: '닫기',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: '설정',
    home: '홈',
    howToPlay: '플레이 방법',
    pieceRules: '기물 규칙',
    language: '언어',
    manageSubscription: '구독 관리',
    gameHistory: '게임 기록',
    analytics: '분석',
    premiumAccount: '프리미엄 계정',
    chatEnabled: '채팅: 켜짐',
    chatDisabled: '채팅: 꺼짐',
  },

  // Piece Rules
  pieceRules: {
    title: '기물 규칙',
    description: '기물 이동 학습',
    selectPiece: '기물 선택',
    selectedLabel: '선택됨:',
    statusLabel: '상태:',
    statusReady: '준비',
    statusViewing: '보는 중',
    movement: '이동',
    regularMovement: '일반 이동',
    ability: '능력',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: '이동',
    savage: '야생',
    birdtype: '새 타입',
    birdType: '새 타입',
    wallBlock: '벽 막기',
    moveblocks: '이동 막기',
    wallclimb: '벽 오르기',
    lilypad: '수련잎',
    poisonous: '독성',
    meadow: '초원',
    parasiticfungi: '기생 균류',
    zombification: '좀비화',
    fungi: '균류',
    traverse: '횡단',
    capture: '포획',
    faint: '기절',
    leap: '도약',
    swing: '그네',
    consume: '소비',
    gamble: '도박',
    entangle: '얽힘',
    ink: '잉크',
    rotate: '회전',
    backstep: '뒤로 물러남',
    trample: '짓밟기',
    charge: '돌진',
    lane: '레인',
    snakestrike: '뱀 공격',
    shedskin: '허물벗기',
    house: '집',
    plant: '식물 타입',
    planttype: '식물 타입',
    capturehost: '숙주 포획',
    contagion: '전염',
    lonewolf: '외로운 늑대',
    hop: '깡충',
    decay: '부패',
    slide: '미끄러짐',
    block: '막기',
    poison: '독',
    infection: '감염',
    howl: '울부짖음',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: '곰은 체스의 킹처럼 모든 방향으로 한 칸씩 이동할 수 있습니다',
    bearMovementPost: '아군 기물에만 막힙니다 (나무는 예외, 곰은 나무에 오를 수 있습니다!)',
    bearSavage: '곰은 코뿔소 막기와 같은 방어 능력을 극복할 수 있습니다',
    bearSavagePost: '야생을 사용하면 곰은 어느 방향에서든 기물을 포획할 수 있어 치명적입니다',

    // Crane
    craneMovement: '학은 직선으로 1~2칸 이동할 수 있습니다',
    craneMovementPost: '학은 다른 기물 위로 날아갈 수도 있습니다!',
    craneBirdType: '새 타입 기물은 대형 또는 포식자 기물을 포획할 수 없습니다',
    craneBirdTypePost: '여기에는 나무, 코뿔소, 곰, 늑대가 포함됩니다',

    // Frog
    frogMovement: '개구리는 대각선으로 2칸 도약합니다',
    frogMovementPost: '한 칸만 점프할 수는 없습니다',
    frogWallBlock: '개구리의 일반 2칸 경로가 벽이나 다른 기물에 막히면 포획할 수 없습니다',
    frogWallBlockPost: '일반 이동이 대각선으로 1칸으로 단축됩니다',
    frogWallClimb: '개구리가 보드의 벽(A열 또는 E열)에 있을 때 위아래로 한 칸 이동할 수 있습니다',
    frogWallClimbPost: '아군 기물이나 개구리 앞의 코뿔소에 막히지 않는 한',
    frogLilypad: '개구리가 게임에서 아직 이동하지 않았다면, 강력한 방어 능력으로 처음 3개 랭크 중 어디로든 이동할 수 있습니다',
    frogLilypadPost: '수련잎 점프를 사용하여 일반 기물을 포획할 수 있지만, 자신보다 높은 랭크의 코뿔소는 예외입니다',
    frogPoisonous: '동물이 개구리 기물을 포획하면 중독됩니다!',
    frogPoisonousPost: '중독된 기물은 회복되기 전에 다음 가능한 턴을 건너뜁니다',

    // Fungi
    fungiMovement: '균류는 모든 방향으로 한 칸 이동할 수 있습니다',
    fungiMovementPost: '아군 기물에만 막힙니다',
    fungiMeadow: '균류는 적 나무 기물의 이동 능력을 감소시킵니다',
    fungiMeadowPost: '적 나무 기물은 균류 기물 1칸 이내로 이동할 수 없습니다',
    fungiParasitic: '균류는 적 나무 기물을 고정시킬 수 있습니다',
    fungiParasiticPost: '균류가 적 나무의 1칸 이내에 있으면 균류가 떨어지거나 포획될 때까지 이동할 수 없습니다',
    fungiZombification: '균류는 자신을 포획하는 적 동물 기물을 좀비화하여 한 턴 동안 적 동물을 제어할 수 있습니다',
    fungiZombificationPost: '좀비화된 기물은 그 턴 동안 균류 기물로도 간주되며, 균류가 킹이었더라도 그 턴이 끝날 때까지 게임은 끝나지 않습니다',
    fungiFungi: '버섯',
    fungiFungiPost: '독, 얽힘, 바이러스 감염과 같은 것들이 있지만, 좀비화는 다른 것들을 좀비화할 수 있으므로 예외입니다!',

    // Goat
    goatMovement: '염소는 모든 방향으로 한 칸 이동할 수 있습니다',
    goatMovementPost: '염소는 천천히 움직이지만 강력한 능력을 가지고 있습니다',
    goatTraverse: '염소는 연결된 다른 기물을 가로질러 엄청난 이동 잠재력을 만들 수 있습니다',
    goatTraversePost: '염소는 기절한 염소나 바이러스와 같은 작은 기물 위로 횡단할 수 없습니다',
    goatCapture: '염소는 포식자를 포획할 수 없습니다',
    goatCapturePost: '곰이나 늑대와 같은',
    goatFaint: '염소는 나무와 코뿔소 같은 대형 기물을 제외하고는 포획을 피하기 위해 기절할 수 있습니다',
    goatFaintPost: '기절한 동안 상대는 기절한 염소 위에 "서서" 이동을 막을 수 있습니다',

    // Monkey
    monkeyMovement: '원숭이는 모든 방향으로 한 칸 이동할 수 있습니다',
    monkeyMovementPost: '활용할 다른 기물이 없으면 원숭이는 이동이 제한됩니다',
    monkeyLeap: '원숭이는 체커 게임처럼 직선으로 다른 기물 위를 뛰어넘어 엄청난 이동 잠재력을 가집니다',
    monkeyLeapPost: '하지만 적 기물을 뛰어넘으면 원숭이는 생존을 위해 주사위를 굴려야 하며, 뛰어넘는 각 적마다 1/6의 포획 확률이 있습니다!',
    monkeySwing: '원숭이가 나무 위를 뛰어넘으면 보너스 턴을 얻습니다',
    monkeySwingPost: '나무 그네를 사용하면 원숭이와 나무 기물 간의 강력한 시너지 콤보가 만들어집니다',
    monkeyConsume: '원숭이는 균류 기물을 소비하여 보너스 턴을 얻을 수 있습니다',
    monkeyConsumePost: '다른 보너스 턴과 결합하면 파괴적인 조합으로 이어집니다',
    monkeyGamble: '적을 뛰어넘기 위해 주사위를 굴리는 것 외에도, 원숭이는 곰을 포획하기 위해 도박을 해야 합니다',
    monkeyGamblePost: '원숭이는 6면 주사위에서 5 또는 6을 굴려야 곰을 포획할 수 있으며, 그렇지 않으면 자신이 포획됩니다',

    // Octopus
    octopusMovement: '문어는 모든 방향으로 한 칸 이동합니다',
    octopusCapture: '문어는 직각으로만 포획할 수 있습니다',
    octopusCapturePost: '문어는 복잡한 방식으로 기물을 포획하거나 얽을 수 있으므로 항상 빨간색 포획과 보라색 얽힘을 확인하세요!',
    octopusEntangle: '문어는 인접한 적 기물을 얽어 고정시킬 수 있으며, 한 칸 이동하여 적을 얽을 수도 있습니다!',
    octopusEntanglePost: '얽힌 기물은 문어가 떨어지거나 포획될 때까지 이동할 수 없습니다',
    octopusInk: '문어는 잉크를 사용하여 위험한 상황에서 탈출하고 최대 3개의 그림자를 만들 수 있습니다',
    octopusInkPost: '적을 혼란스럽게 하고 흥미로운 미끼와 회피 플레이를 가능하게 합니다',

    // Penguin
    penguinMovement: '펭귄은 설정된 방향으로 직선으로 미끄러지며 벽이나 기물이 이동을 막을 때까지 움직입니다',
    penguinMovementPost: '이동 후 펭귄은 같은 턴 내에 최종 방향을 설정할 수도 있습니다',
    penguinRotate: '경기 시작 시 펭귄은 아래를 향하고 있으며 미끄러지기 전에 회전해야 하며, 이를 잠자기라고도 합니다',
    penguinRotatePost: '펭귄은 어느 위치에서든 이동 대신 회전을 선택할 수 있습니다',
    penguinBirdType: '펭귄은 학처럼 제한된 포획 능력을 가지고 있으며, 나무, 코뿔소, 곰, 늑대와 같은 대형 또는 포식자 기물을 포획할 수 없습니다',
    penguinBirdTypePost: '포획 후 펭귄은 전략적 위치 선정을 위해 어느 방향으로든 회전할 수 있습니다',

    // Rhino
    rhinoMovement: '코뿔소는 앞으로만 두 칸 이동합니다',
    rhinoMovementPost: '한 칸만 이동할 수는 없습니다',
    rhinoBackStep: '코뿔소는 왼쪽 뒤 또는 오른쪽 뒤로 이동할 수 있습니다',
    rhinoCharge: '코뿔소는 게임당 한 번 돌진 능력을 사용하여 앞으로 한 칸 더 이동할 수 있습니다',
    rhinoChargePost: '파괴적인 이동과 포획 잠재력으로 이어집니다',
    rhinoTrample: '코뿔소는 짓밟기로 이동 경로의 모든 기물을 포획합니다',
    rhinoTramplePost: '기절한 염소 기물 포함',
    rhinoLane: '코뿔소는 다른 아군 기물과 자리를 바꿔 전략적 레인 플레이를 할 수 있습니다',
    rhinoLanePost: '하지만 코뿔소와 아군 기물이 모두 이동하지 않은 경우에만',

    // Snake
    snakeMovement: '뱀은 직선으로 2칸 이동할 수 있습니다',
    snakeMovementPost: '뱀은 벽이나 아군 기물에 막히지 않는 한 정확히 2칸 이동합니다',
    snakeMoveBlocks: '벽이나 포획할 수 없는 기물에 막히면 뱀의 이동은 1칸으로 단축됩니다',
    snakeMoveBlocksPost: '중간에 기물이 있어도 여전히 2칸 이동할 수 있습니다',
    snakeStrike: '적 동물이 있으면 뱀은 앞으로 3칸 공격할 수 있습니다',
    snakeStrikePost: '경로를 막는 중간 기물이 없는 한',
    snakeShedskin: '게임당 한 번, 뱀은 허물을 벗고 칸이 비어 있으면 첫 랭크로 돌아갈 수 있습니다',
    snakeShedskinPost: '이 재탄생은 뱀에게 각 게임마다 추가 생명을 줍니다',

    // Tree
    treeMovement: '나무는 앞으로 한 칸 또는 같은 랭크의 좌우 어느 칸으로든 이동할 수 있습니다',
    treeMovementPost: '경로가 막히지 않는 한',
    treeHouse: '나무는 다른 기물을 수용하여 나무에 오를 수 없는 적으로부터 보호할 수 있습니다. 곰, 학, 개구리, 균류, 염소, 원숭이, 문어, 뱀과 같은 기물이 오를 수 있습니다',
    treeHousePost: '나무에 오를 수 있는 기물이 공격하면 수용된 기물만 포획하여 나무를 보호합니다',
    treeTrample: '나무는 코뿔소처럼 칸으로 이동할 때 그 칸의 모든 기물을 포획합니다',
    treeTramplePost: '기절한 염소 포함',
    treePlant: '나무는 동물이 아닌 식물이므로 여러 효과에 면역입니다',
    treePlantPost: '독, 좀비화, 얽힘, 바이러스 감염과 같은!',

    // Virus
    virusMovement: '바이러스는 2칸 떨어진 동물이 점유한 칸으로만 이동할 수 있습니다',
    virusMoveBlocks: '바이러스는 벽 옆에 있으면 한 칸만 이동할 수 있습니다',
    virusCaptureHost: '바이러스가 동물 기물에 착륙(진입)하면 감염만 시키며, 감염된 상태에서도 일반 플레이를 계속할 수 있습니다',
    virusCaptureHostPost: '바이러스는 감염된 숙주를 떠날 때만 기물을 포획합니다',
    virusContagion: '바이러스는 한 턴에 여러 숙주를 감염시켜 빠르게 확산될 수 있습니다',
    virusContagionPost: '전염을 통해 바이러스는 각 턴마다 원하는 만큼 합법적인 이동을 할 수 있습니다',

    // Wolf
    wolfMovement: '늑대는 체스의 나이트처럼 L자 모양으로 이동할 수 있습니다',
    wolfMovementPost: '다른 기물에 의해 방해받지 않습니다',
    wolfLoneWolf: '늑대',
    wolfLoneWolfPost: '늑대는 기절한 염소나 바이러스 아군만 있어도 혼자라고 간주합니다',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 드래그하여 탐색 • 핀치하여 확대',
    dragToExploreDesktop: '🖱️ 드래그하여 탐색 • 스크롤하여 확대',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: '뒤로',
    next: '다음',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: '샌드박스',
    description: '실험 및 연습',
    mode: '모드:',
    modeValue: '샌드박스',
    status: '상태:',
    statusReady: '준비',
    clearBoard: '보드 지우기',
  },

  // Multiplayer
  multiplayer: {
    title: '멀티플레이어',
    description: '상대를 찾아 경쟁하세요!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: '배치 경기',
    matchProgress: '경기 진행',
    gamesCompleted: '{games} / 10 게임 완료',
    estimatedFinalRating: '예상 최종 등급',
    startingRating: '시작 등급',
    matchesRemaining: '{matches} 경기 남음',
    findPlacementMatch: '배치 경기 찾기',

    // Matchmaking modes
    findMatch: '경기 찾기',
    competitive: '경쟁',
    competitiveDesc: '순위가 비슷한 상대 찾기',
    quick: '빠른 경기',
    quickDesc: '빠르게 경쟁 경기 찾기',
    casual: '캐주얼',
    casualDesc: '랭크 없음 - 재미를 위한 플레이!',
    placement: '배치',
    placementDesc: '랭크를 받으려면 10경기를 완료하세요',
    startSearch: '검색 시작',

    // Searching
    searching: '검색 중...',
    mode: '모드:',
    inQueue: '대기열:',
    players: '플레이어',
    playersPlural: '플레이어',
    cancelSearch: '검색 취소',

    // Game info
    status: '상태:',
    ready: '준비',
    selectingKing: '킹 선택 중',
    placingPieces: '기물 배치 중',
    playing: '플레이 중',
    gameType: '게임 유형:',
    opponent: '상대:',
    opponentElo: '상대 ELO:',
    unranked: '랭크 없음',

    // Piece placement
    dragPieces: '기물을 보드로 드래그',
    lightPieces: '밝은 기물 (당신)',
    darkPieces: '어두운 기물 (당신)',

    // Waiting states
    waitingForOpponent: '상대 대기 중...',
    waitingForKing: '상대가 킹을 선택할 때까지 대기 중...',

    // Warnings
    invalidPlacement: '잘못된 배치',
    lightTurn: '밝은 플레이어의 턴입니다!',
    darkTurn: '어두운 플레이어의 턴입니다!',
    onlyLightPieces: '밝은 기물만 배치할 수 있습니다!',
    onlyDarkPieces: '어두운 기물만 배치할 수 있습니다!',
    mustPlaceOnRow: '{color} 기물은 {row}번째 줄에 배치해야 합니다!',

    // Chat
    chat: '채팅',
    typeMessage: '메시지 입력...',
    send: '전송',
  },

  // Main Page
  mainPage: {
    title: '애니멀 체스',
    subtitle: '인간을 위한 게임',
    playersOnline: '현재 온라인 플레이어',
    placement: '배치',
    placementProgress: '배치',
    challengeAI: 'AI 도전',
    multiplayer: '멀티플레이어',
    sandbox: '샌드박스',
    tutorials: '튜토리얼',
    shop: '상점',
    collection: '컬렉션',
    history: '기록',
    analytics: '분석',
    courses: '강좌',
    upgradeAccount: '계정 업그레이드',
    signIn: '로그인',
    playAsGuest: '게스트로 플레이',
    welcomeBack: '다시 오신 것을 환영합니다! 보통 다음으로 플레이합니다',

    // Learn the Pieces section
    learnThePieces: '기물 학습',

    // Learn the Rules section
    learnTheRules: '규칙 학습',
    premiseTitle: '전제',
    premiseText: 'Zodiac은 13개 기물 명단에서 숨겨진 킹이 있는 체스 대안으로, 고유한 명단을 선택한 다음 상대를 속여 5x8 보드에서 그들을 물리치세요',
    selectionTitle: '선택',
    selectionText: '게임을 시작하려면 비밀리에 킹을 선택한 다음 상대와 번갈아 가며 5개의 기물을 배치하여 5천억 개 이상의 초기 상태 중 하나를 만드세요.',
    objectiveTitle: '목표',
    objectiveText: '상대를 읽어 그들의 비밀 킹을 포획하거나 킹을 보드 반대편으로 이동시켜 승리를 확보하세요!',
    competeTitle: '경쟁',
    competeText: '래더에서 실력을 시험하고, 새로운 개인 기술과 전략을 개발하고, 순위를 올려 최고와 겨루세요!',
    fullRulesButton: '전체 공식 규칙은 여기를 클릭하세요',

    // FAQ section
    faqTitle: '자주 묻는 질문',
    faqQuestion1: 'Zodiac 체스의 아이디어는 무엇인가요?',
    faqAnswer1: 'Zodiac 체스는 Bobby Fischer가 Chess960을 만든 영감에 대한 말에서 영감을 받았습니다. 우리는 기계적 암기와 싸우고 헤아릴 수 없는 깊이에서 인간의 직관을 기념하는 아이디어를 확장하고 싶었습니다!',
    faqQuestion2: '왜 체스 대안이 필요한가요',
    faqAnswer2: '필요하지 않습니다! Zodiac은 사람들이 체스를 플레이하는 것을 방해하고 싶지 않습니다! 자체적인 장단점이 있는 다른 옵션이며, 재미있게 즐기시고 새로운 플레이를 활성화하기 위해 이 게임을 조정하는 데 도움을 주시기 바랍니다',
    faqQuestion3: 'Zodiac 체스에서 어떻게 이기나요?',
    faqAnswer3: '세 가지 방법으로 이길 수 있습니다: 상대의 숨겨진 킹 기물을 포획하거나, 자신의 킹을 보드 반대편으로 이동시키거나, 시간 제한이 있는 경기에서 상대의 시간이 다 되게 하는 것입니다',
    faqQuestion4: '이것이 FAQ인가요?',
    faqAnswer4: '예, FAQ에 나열된 모든 질문을 볼 수 있으며 더 자세한 내용을 원하면 질문을 클릭한 다음 지금 읽고 있는 이 세부 정보와 같은 세부 정보를 읽을 수 있습니다',
    faqQuestion5: '일반적인 게임은 얼마나 걸리나요?',
    faqAnswer5: '각 게임은 매우 다릅니다! 일부 게임은 2턴 만에 끝나고 일부는 30분이 걸릴 수 있으며, 일반적으로 5-15분 정도 걸립니다!',
    faqQuestion6: '아무도 합법적인 이동을 할 수 없으면 어떻게 되나요?',
    faqAnswer6: '플레이어가 합법적인 이동을 할 수 없으면(교착 상태) 게임은 무승부로 끝납니다. 게임은 반복(같은 보드 상태 3번) 또는 플레이어 간의 상호 합의로도 무승부로 끝날 수 있습니다!',

    // About section
    aboutButton: '정보',
    privacyPolicy: '개인정보 보호정책',
    developerInterface: '개발자 인터페이스',
  },

  // About Modal
  about: {
    title: 'Zodiac 정보',
    paragraph1: 'Zodiac은 LoL 및 DotA와 같은 게임의 기물 선택 요소와 포커 또는 소셜 추론 게임의 블러핑 메커니즘을 결합한 체스 유사 보드 게임입니다.',
    paragraph2: '게임의 초기 버전은 2014년에 Shadow Chess라는 이름으로 만들어졌습니다. 2018년에는 균형 잡혔지만 고유한 이동 패턴과 능력을 가진 재미있는 기물 명단을 포함하여 오늘날 보는 것으로 재설계되었습니다.',
    paragraph3: '우리의 비전은 모든 사용자 게임플레이 데이터를 기록하여 게임플레이를 새롭게 유지하고 새로운 플레이를 장려하기 위해 게임을 계속 진화시키는 것입니다.',
    paragraph4: 'Zodiac의 거대한 검색 공간, 숨겨진 정보 및 오프닝 보드 위치로 우리는 AI 지배를 막고 Zodiac을 인간을 위한 게임으로 유지하기를 희망합니다!',
  },

  // Privacy Policy
  privacy: {
    title: '개인정보 보호정책',
    lastUpdated: '마지막 업데이트',

    introduction: {
      title: '소개',
      p1: 'Zodiac Chess("우리", "우리의" 또는 "우리를")에 오신 것을 환영합니다. 우리는 귀하의 개인정보를 보호하고 안전하고 즐거운 게임 경험을 제공하는 데 전념하고 있습니다. 이 개인정보 보호정책은 귀하가 우리 웹사이트와 게임을 사용할 때 귀하의 정보를 수집, 사용, 공개 및 보호하는 방법을 설명합니다.',
      p2: 'Zodiac Chess를 사용함으로써 귀하는 이 정책에 따라 정보의 수집 및 사용에 동의합니다. 우리의 정책과 관행에 동의하지 않으면 우리 서비스를 사용하지 마십시오.',
      contact: '문의:',
    },

    infoCollect: {
      title: '수집하는 정보',
      accountInfo: {
        title: '1. 계정 정보',
        item1: '이메일 주소: 계정 생성 및 통신에 필요',
        item2: '사용자 이름: 선택한 표시 이름',
        item3: '비밀번호: 암호화되어 안전하게 저장',
      },
      gameData: {
        title: '2. 게임 데이터',
        item1: '게임 통계: 승, 패, ELO 등급, 배치 경기 진행',
        item2: '게임플레이 데이터: 기물 선택, 이동, 사용된 전략',
        item3: '경기 기록: 플레이한 게임 기록, 맞붙은 상대',
        item4: '게임 내 구매: 장식 아이템 및 프리미엄 멤버십 상태',
      },
      technicalData: {
        title: '3. 기술 데이터',
        item1: '장치 정보: 브라우저 유형, 운영 체제',
        item2: '사용 데이터: 방문한 페이지, 소요 시간, 사용된 기능',
        item3: '로컬 저장소: 언어 기본 설정, UI 설정, 임시 게임 상태',
      },
    },

    children: {
      title: '어린이 개인정보(COPPA 준수)',
      p1: 'Zodiac Chess는 가족 친화적이고 어린이를 포함한 모든 연령대의 플레이어에게 적합하도록 설계되었습니다. 우리는 어린이 온라인 개인정보 보호법(COPPA)을 준수하기 위해 특별한 주의를 기울입니다.',
      p2: '13세 미만 사용자의 경우: 계정 생성이나 데이터 수집이 필요하지 않은 게스트 플레이 모드를 사용하는 것을 권장합니다. 게스트 계정은 텍스트 채팅 기능에 액세스할 수 없어 어린이가 더 넓은 인터넷과의 통신에 노출되지 않도록 합니다. 어린이가 계정을 만들면 개인 정보를 수집하기 전에 부모의 동의가 필요합니다.',
      p3: '우리는 확인된 부모의 동의 없이 13세 미만 어린이의 개인 정보를 고의로 수집, 사용 또는 공유하지 않습니다.',
      p4: '채팅 안전: 모든 게스트/임시 계정에 대해 텍스트 채팅이 자동으로 비활성화됩니다. 표준 계정 보유자는 언제든지 계정 설정에서 채팅 기능을 비활성화할 수 있습니다.',
      parentalRights: '부모는 다음과 같은 권리가 있습니다:',
      right1: '자녀의 개인 정보 검토',
      right2: '자녀의 데이터 삭제 요청',
      right3: '자녀의 정보의 추가 수집 또는 사용 거부',
      contactUs: '이러한 권리를 행사하거나 자녀가 우리에게 개인 정보를 제공했다고 생각되면 contact@zodiac-chess.com으로 즉시 문의하십시오',
    },

    howWeUse: {
      title: '귀하의 정보를 사용하는 방법',
      item1: '게임 서비스 제공 및 개선',
      item2: '기술 수준에 따라 적절한 상대 매치',
      item3: '진행 상황, 통계 및 업적 추적',
      item4: '프리미엄 멤버십 및 장식 아이템 결제 처리',
      item5: '중요한 서비스 공지 및 업데이트 전송',
      item6: '게임 균형 및 기능 개선을 위한 게임플레이 데이터 분석',
    },

    thirdParty: {
      title: '제3자 서비스',
      firebase: {
        title: 'Firebase (Google)',
        description: '인증, 데이터베이스 저장 및 멀티플레이어 기능에 Firebase를 사용합니다. Firebase는 개인정보 보호정책에 설명된 대로 특정 데이터를 수집할 수 있습니다.',
      },
      stripe: {
        title: 'Stripe',
        description: '프리미엄 멤버십 및 앱 내 구매 결제 처리에 Stripe를 사용합니다. Stripe는 모든 결제 카드 정보를 처리하며 - 우리는 귀하의 전체 결제 세부 정보를 보거나 저장하지 않습니다.',
      },
      netlify: {
        title: 'Netlify',
        description: '우리 웹사이트는 Netlify에서 호스팅되며, IP 주소 및 액세스 로그와 같은 표준 웹 호스팅 데이터를 수집할 수 있습니다.',
      },
      adsense: {
        title: 'Google AdSense (향후)',
        description: 'Google AdSense를 통해 광고를 표시할 수 있습니다. 이러한 광고는 개인화를 위해 쿠키를 사용할 수 있습니다. 어린이 대상 콘텐츠의 경우 COPPA 준수를 위해 개인화되지 않은 광고만 표시합니다.',
      },
      viewPolicy: '개인정보 보호정책 보기',
    },

    cookies: {
      title: '쿠키 및 로컬 저장소',
      description: '귀하의 경험을 향상시키기 위해 브라우저 로컬 저장소(쿠키와 유사)를 사용합니다:',
      item1: '언어 기본 설정: 선택한 언어 기억',
      item2: '계정 세션: 로그인 상태 유지(Firebase와 작동)',
      item3: '게임 설정: UI 기본 설정 및 샌드박스 설정 기억',
      item4: '광고 쿠키: 동의하면 제3자 광고 서비스가 광고 개인화를 위해 쿠키를 사용할 수 있습니다',
    },

    security: {
      title: '데이터 보안',
      p1: '귀하의 정보를 보호하기 위해 적절한 보안 조치를 구현합니다:',
      item1: '비밀번호 암호화: 모든 비밀번호는 업계 표준 방법을 사용하여 암호화됩니다',
      item2: '보안 연결: 모든 데이터 전송에 HTTPS 암호화',
      item3: 'Firebase 보안 규칙: 엄격한 데이터베이스 액세스 제어',
      p2: '그러나 인터넷을 통한 전송 방법은 100% 안전하지 않습니다. 귀하의 데이터를 보호하기 위해 노력하지만 절대적인 보안을 보장할 수 없습니다.',
    },

    retention: {
      title: '데이터 보유',
      p1: '다음과 같이 귀하의 데이터를 보유합니다:',
      item1: '활성 계정: 계정이 활성 상태인 동안 데이터가 보유됩니다',
      item2: '비활성 계정: 계정이 10년 동안 비활성 상태이면 데이터를 삭제할 수 있습니다',
    },

    rights: {
      title: '귀하의 개인정보 보호 권리',
      description: '위치에 따라 다음과 같은 권리가 있을 수 있습니다:',
      access: {
        title: '액세스:',
        description: '개인 데이터 사본 요청',
      },
      correction: {
        title: '수정:',
        description: '데이터 수정 요청',
      },
      deletion: {
        title: '삭제:',
        description: '계정 및 데이터 삭제 요청',
      },
      portability: {
        title: '데이터 이동:',
        description: '이동 가능한 형식으로 데이터 요청',
      },
      optOut: {
        title: '옵트아웃:',
        description: '마케팅 커뮤니케이션 옵트아웃',
      },
      contact: '이러한 권리를 행사하려면 contact@zodiac-chess.com으로 문의하십시오',
    },

    international: {
      title: '국제 사용자',
      p1: 'Zodiac Chess는 뉴질랜드에서 운영됩니다. 뉴질랜드 외부에서 우리 서비스에 액세스하는 경우 귀하의 정보가 뉴질랜드 및 서비스 제공업체가 운영되는 다른 국가로 전송, 저장 및 처리될 수 있음을 알아두십시오.',
      p2: '우리 서비스를 사용함으로써 귀하는 귀하의 거주 국가 외부의 국가로 귀하의 정보를 전송하는 데 동의하며, 이러한 국가는 다른 데이터 보호법을 가질 수 있습니다.',
    },

    changes: {
      title: '이 개인정보 보호정책의 변경',
      description: '우리는 때때로 이 개인정보 보호정책을 업데이트할 수 있습니다. 이 페이지에 새 개인정보 보호정책을 게시하고 "마지막 업데이트" 날짜를 업데이트하여 변경 사항을 알려드립니다. 중요한 변경 사항은 이메일 또는 우리 웹사이트의 눈에 띄는 공지를 통해 전달됩니다.',
    },

    contact: {
      title: '문의',
      description: '이 개인정보 보호정책 또는 우리의 데이터 관행에 관한 질문, 우려 또는 요청이 있으면 문의하십시오:',
      email: '이메일:',
      company: '회사:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: '서비스 약관',
    lastUpdated: '최종 업데이트',
    back: '뒤로',
    viewPrivacyPolicy: '개인정보 처리방침 보기',
    acknowledgment: 'Zodiac Chess를 사용함으로써 귀하는 본 서비스 약관을 읽고 이해했으며 이에 구속되는 것에 동의함을 인정합니다.',
    acceptance: {
      title: '1. 약관 동의',
      p1: 'Zodiac Chess("서비스")에 접근하고 사용함으로써 귀하는 본 서비스 약관에 구속되는 것을 수락하고 동의합니다. 이 약관에 동의하지 않으시면 서비스를 사용하지 마십시오.',
      p2: '당사는 언제든지 이 약관을 수정할 권리를 보유합니다. 변경 후 서비스의 계속 사용은 수정된 약관의 수락을 구성합니다.',
    },
    description: {
      title: '2. 서비스 설명',
      p1: 'Zodiac Chess는 특수 능력을 가진 고유한 동물 말을 특징으로 하는 온라인 전략 보드 게임입니다. 서비스에는 다음이 포함됩니다:',
      feature1: 'AI 상대와의 싱글 플레이어 게임플레이',
      feature2: '멀티플레이어 매치메이킹 및 경쟁 플레이',
      feature3: '대화형 튜토리얼 및 학습 자료',
      feature4: '계정 생성 및 진행 상황 추적',
      feature5: '선택적 프리미엄 구독 기능',
      feature6: '코스메틱 커스터마이제이션 옵션',
    },
    accounts: {
      title: '3. 사용자 계정',
      eligibility: {
        title: '3.1 자격',
        p1: '계정을 만들려면 최소 13세 이상이어야 합니다. 13세 미만 사용자는 부모의 감독 하에 게스트 플레이 모드를 사용할 수 있지만 계정을 만들 수 없습니다.',
      },
      responsibilities: {
        title: '3.2 계정 보안',
        p1: '귀하는 다음에 대한 책임이 있습니다:',
        item1: '비밀번호의 기밀성 유지',
        item2: '계정에서 발생하는 모든 활동',
        item3: '무단 사용 시 즉시 당사에 통지',
        p2: '당사는 무단 계정 접근으로 인한 손실이나 손해에 대해 책임지지 않습니다.',
      },
      prohibited: {
        title: '3.3 금지된 활동',
        p1: '다음은 허용되지 않습니다:',
        item1: '계정을 다른 사람과 공유',
        item2: '여러 계정을 사용하여 순위 조작',
        item3: '봇, 스크립트 또는 자동화 도구를 사용하여 게임 플레이',
        item4: '다른 플레이어를 괴롭히거나 학대하거나 위협',
        item5: '버그나 결함을 악용하여 불공정한 이점 획득',
        item6: '리버스 엔지니어링 또는 소스 코드 접근 시도',
        p2: '이러한 규칙 위반은 계정 정지 또는 영구 금지로 이어질 수 있습니다.',
      },
    },
    premium: {
      title: '4. 프리미엄 구독',
      billing: {
        title: '4.1 청구',
        p1: '프리미엄 구독은 Stripe를 통해 처리됩니다. 프리미엄 구독을 구매함으로써 취소할 때까지 반복적으로 결제 수단에 청구하는 것을 승인합니다.',
        p2: '구독료는 다음과 같습니다:',
        item1: '월간 플랜: 구매일 기념일에 매월 청구',
        item2: '연간 플랜: 구매일 기념일에 매년 청구',
        p3: '가격은 활성 구독자에게 30일 전 통지로 변경될 수 있습니다.',
      },
      cancellation: {
        title: '4.2 취소',
        p1: '계정 설정을 통해 또는 지원팀에 연락하여 언제든지 구독을 취소할 수 있습니다. 취소는 현재 청구 기간이 끝날 때 적용됩니다.',
        p2: '취소 후에도 결제된 기간이 끝날 때까지 프리미엄 기능을 유지합니다.',
      },
      refunds: {
        title: '4.3 환불',
        p1: '월간 구독: 부분 월에 대한 환불 없음. 향후 청구를 중지하려면 언제든지 취소하십시오.',
        p2: '연간 구독: 구매 후 7일 이내에 요청하면 전액 환불. 7일 이후의 환불은 당사의 재량에 따릅니다.',
        p3: '코스메틱 구매: 일반적으로 환불 불가. 예외적인 상황에 대해서는 지원팀에 문의하십시오.',
      },
    },
    acceptable: {
      title: '5. 허용 가능한 사용 정책',
      p1: '귀하는 Zodiac Chess를 존중하고 합법적인 방식으로 사용하는 데 동의합니다. 금지된 행위에는 다음이 포함됩니다:',
      item1: '부정행위, 해킹 또는 게임 메카닉 악용',
      item2: '괴롭힘, 혐오 발언 또는 차별적 언어',
      item3: '스팸, 광고 또는 권유',
      item4: '부적절한 콘텐츠 공유(채팅 또는 사용자 생성 콘텐츠가 활성화된 경우)',
      item5: '다른 사용자 또는 직원 사칭',
      item6: '서비스를 방해하거나 손상시키려는 시도',
      p2: '당사는 위반 사항을 조사하고 필요한 경우 계정 종료 및 당국에 신고를 포함한 적절한 조치를 취할 권리를 보유합니다.',
    },
    intellectual: {
      title: '6. 지적 재산권',
      ownership: {
        title: '6.1 당사 콘텐츠',
        p1: '게임 메카닉, 아트워크, 애니메이션, 사운드 이펙트, 코드 및 디자인을 포함하되 이에 국한되지 않는 모든 게임 콘텐츠는 Animal Chess Limited 또는 당사의 라이선서가 소유합니다.',
        p2: '귀하에게는 개인 오락 목적으로만 서비스를 사용할 수 있는 제한적이고 비독점적이며 양도 불가능한 라이선스가 부여됩니다.',
      },
      userContent: {
        title: '6.2 사용자 콘텐츠',
        p1: '콘텐츠(채팅 메시지, 사용자 이름 또는 프로필 정보 등)를 제출함으로써 귀하는 서비스와 관련하여 해당 콘텐츠를 사용, 표시 및 배포할 수 있는 전 세계적이고 로열티 없는 라이선스를 당사에 부여합니다.',
        p2: '귀하는 제출하는 콘텐츠에 대한 소유권 또는 필요한 권리를 보유하고 있음을 진술합니다.',
      },
    },
    disclaimers: {
      title: '7. 면책 조항 및 책임 제한',
      p1: '서비스는 명시적이든 묵시적이든 어떠한 종류의 보증 없이 "있는 그대로" 제공됩니다.',
      p2: '당사는 다음을 보장하지 않습니다:',
      item1: '서비스가 중단 없이 또는 오류 없이 작동할 것',
      item2: '결함이 수정될 것',
      item3: '서비스에 바이러스나 유해한 구성 요소가 없을 것',
      item4: '서비스 사용 결과가 귀하의 기대를 충족할 것',
      p3: '법률이 허용하는 최대 범위 내에서 당사는 다음에 대해 책임지지 않습니다:',
      item5: '간접적, 우발적 또는 결과적 손해',
      item6: '이익, 데이터 또는 영업권 손실',
      item7: '서비스 중단 또는 데이터 손실',
      item8: '지난 12개월 동안 귀하가 당사에 지불한 금액을 초과하는 손해',
    },
    privacy: {
      title: '8. 개인정보',
      p1: '서비스 사용은 개인 정보를 수집, 사용 및 보호하는 방법을 설명하는 개인정보 처리방침의 적용도 받습니다.',
      p2: '서비스를 사용함으로써 귀하는 개인정보 처리방침에 설명된 당사의 데이터 관행에 동의합니다.',
    },
    changes: {
      title: '9. 약관 변경',
      p1: '당사는 언제든지 본 서비스 약관을 수정할 권리를 보유합니다. 중요한 변경 사항은 다음을 통해 사용자에게 알립니다:',
      item1: '등록된 사용자에게 이메일 알림',
      item2: '웹사이트에 눈에 띄는 공지',
      item3: '이 페이지 상단의 "최종 업데이트" 날짜 업데이트',
      p2: '변경 후 서비스의 계속 사용은 수정된 약관의 수락을 구성합니다.',
    },
    governing: {
      title: '10. 준거법',
      p1: '본 서비스 약관은 법률 충돌 원칙에 관계없이 뉴질랜드 법률의 적용을 받습니다.',
      p2: '이 약관 또는 서비스 사용으로 인해 발생하는 모든 분쟁은 뉴질랜드 법원에서 해결됩니다.',
    },
    contact: {
      title: '11. 연락처 정보',
      p1: '본 서비스 약관에 관한 질문, 우려 사항 또는 지원:',
      email: '이메일:',
      company: '회사:',
      address: '주소:',
    },
    severability: {
      title: '12. 분리 가능성',
      p1: '이 약관의 조항이 집행 불가능하거나 무효로 판명되면 해당 조항은 필요한 최소 범위로 제한되거나 제거되며 나머지 조항은 완전한 효력을 유지합니다.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: '쿠키 정책',
    lastUpdated: '최종 업데이트',
    browserInstructions: {
      chrome: '설정 → 개인정보 및 보안 → 쿠키',
      firefox: '설정 → 개인정보 및 보안 → 쿠키 및 사이트 데이터',
      safari: '환경설정 → 개인정보 → 쿠키 및 웹사이트 데이터',
      edge: '설정 → 개인정보, 검색 및 서비스 → 쿠키',
    },
    cookieTable: {
      name: '쿠키 이름',
      purpose: '목적',
      duration: '기간',
      type: '유형',
    },
    relatedPolicies: {
      title: '관련 정책',
      description: '당사의 데이터 처리 방식에 대한 자세한 내용은 다음을 참조하세요:',
      privacy: '개인정보 처리방침',
      terms: '서비스 약관',
    },

    introduction: {
      title: '소개',
      p1: '이 쿠키 정책은 Zodiac Chess("당사" 또는 "우리")가 귀하가 당사 웹사이트를 방문할 때 쿠키 및 유사 기술을 어떻게 사용하는지 설명합니다.',
      p2: '당사 웹사이트를 사용함으로써 귀하는 이 정책에 따른 쿠키 사용에 동의합니다. 동의하지 않으시면 브라우저 설정에서 쿠키를 비활성화하거나 당사 웹사이트를 사용하지 마세요.',
    },
    what: {
      title: '쿠키란?',
      p1: '쿠키는 웹사이트를 방문할 때 귀하의 기기(컴퓨터, 스마트폰, 태블릿)에 저장되는 작은 텍스트 파일입니다. 웹사이트가 효율적으로 작동하고 웹사이트 소유자에게 정보를 제공하기 위해 널리 사용됩니다.',
      p2: '쿠키는 귀하의 설정 기억, 사이트 사용 분석, 특정 기능 활성화 등 다양한 목적으로 사용됩니다.',
    },
    types: {
      title: '사용하는 쿠키 유형',
      necessary: {
        title: '1. 필수 쿠키',
        description: '이 쿠키는 웹사이트가 올바르게 작동하는 데 필수적입니다. 이 쿠키 없이는 귀하가 요청한 서비스를 제공할 수 없습니다.',
        examples: '예시:',
        item1: '인증 쿠키 - 계정 로그인 상태 유지',
        item2: '보안 쿠키 - 사기 행위로부터 보호',
        item3: '세션 쿠키 - 세션 중 게임 상태 유지',
        item4: '쿠키 동의 설정 - 귀하의 쿠키 선택 기억',
      },
      analytics: {
        title: '2. 분석 쿠키',
        description: '이 쿠키는 페이지 방문, 체류 시간, 사용된 기능에 대한 익명 정보를 수집하여 방문자가 당사 웹사이트와 어떻게 상호작용하는지 이해하는 데 도움을 줍니다.',
        provider: '제공자: Firebase Analytics (Google)',
        purpose: '목적:',
        item1: '웹사이트 트래픽 및 사용자 참여 측정',
        item2: '인기 있는 기능과 페이지 파악',
        item3: '사용자 인구통계 이해 (연령대, 대략적인 위치)',
        item4: '웹사이트 성능 및 사용자 경험 개선',
      },
      advertising: {
        title: '3. 광고 쿠키',
        description: '이 쿠키는 귀하와 관련 있는 광고를 표시하는 데 사용됩니다. 또한 광고가 표시되는 횟수를 제한하고 광고 캠페인의 효과를 측정하는 데 도움을 줍니다.',
        provider: '제공자: Google AdSense',
        purpose: '목적:',
        item1: '귀하의 관심사에 기반한 맞춤 광고 표시',
        item2: '광고 성과 및 참여 측정',
        item3: '동일한 광고가 너무 많이 표시되는 것 방지',
        note: '참고: 프리미엄 구독자는 쿠키 설정에 관계없이 광고가 표시되지 않습니다.',
      },
    },
    firstThird: {
      title: '자사 쿠키 vs 타사 쿠키',
      firstParty: {
        title: '자사 쿠키',
        description: 'Zodiac Chess가 직접 설정하는 쿠키입니다. 필수 사이트 기능, 인증 및 설정 기억에 사용됩니다.',
      },
      thirdParty: {
        title: '타사 쿠키',
        description: 'Google Analytics 및 Google AdSense와 같이 당사가 사용하는 외부 서비스에서 설정하는 쿠키입니다. 타사 쿠키는 해당 제공업체의 개인정보 처리방침의 적용을 받습니다.',
      },
    },
    specific: {
      title: '사용 중인 특정 쿠키',
      tableHeader: '아래는 당사 웹사이트에서 사용되는 쿠키의 상세 목록입니다:',
    },
    control: {
      title: '쿠키 제어 방법',
      consent: {
        title: '1. 쿠키 동의 배너',
        description: '당사 웹사이트를 처음 방문하면 쿠키 동의 배너가 표시됩니다. 다음을 할 수 있습니다:',
        item1: '모두 수락 - 모든 쿠키 허용 (필수, 분석, 광고)',
        item2: '선택 사항 거부 - 필수 쿠키만 허용 (분석이나 광고 없음)',
        item3: '사용자 지정 - 허용할 쿠키 유형을 정확히 선택',
      },
      browser: {
        title: '2. 브라우저 설정',
        description: '대부분의 웹 브라우저에서는 설정을 통해 쿠키를 제어할 수 있습니다. 다음을 할 수 있습니다:',
        item1: '모든 쿠키 차단',
        item2: '자사 쿠키만 수락',
        item3: '각 브라우징 세션 후 쿠키 삭제',
        item4: '개별 쿠키 보기 및 삭제',
        links: '주요 브라우저의 쿠키 관리 링크:',
      },
      optOut: {
        title: '3. 수신 거부 도구',
        description: '광고 쿠키의 경우 맞춤 광고를 수신 거부할 수 있습니다:',
        googleLink: 'Google 광고 설정',
        googleDesc: ' - Google 맞춤 광고 관리',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - 관심 기반 광고 수신 거부',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - EU 전용 수신 거부 도구',
      },
    },
    impact: {
      title: '쿠키 비활성화의 영향',
      p1: '쿠키를 비활성화하거나 거부하면 다음 사항에 유의하세요:',
      item1: '웹사이트의 일부 기능이 제대로 작동하지 않을 수 있습니다',
      item2: '방문할 때마다 설정을 다시 입력해야 할 수 있습니다',
      item3: '계정에서 로그아웃될 수 있습니다',
      item4: '필수 쿠키는 사이트 작동에 필요합니다 - 비활성화하면 핵심 기능을 사용할 수 없습니다',
    },
    updates: {
      title: '본 쿠키 정책의 업데이트',
      p1: '당사는 관행의 변경을 반영하거나 법적, 규제 또는 운영상의 이유로 수시로 본 쿠키 정책을 업데이트할 수 있습니다.',
      p2: '중요한 변경 사항은 이 페이지 상단의 "최종 업데이트" 날짜를 업데이트하여 알려드립니다. 이 정책을 주기적으로 검토해 주세요.',
    },
    contact: {
      title: '문의하기',
      p1: '당사의 쿠키 사용 또는 본 쿠키 정책에 대해 질문이 있으시면 다음으로 연락해 주세요:',
      email: '이메일:',
      company: '회사:',
    },
  },

  // Game
  game: {
    yourTurn: '당신의 차례',
    opponentTurn: '상대의 차례',
    victory: '승리!',
    defeat: '패배',
    draw: '무승부',
    resign: '기권',
    offerDraw: '무승부 제안',
  },

  // Game Info
  gameInfo: {
    title: '게임 정보',
    sandboxMode: '샌드박스 모드',
    lightTurn: '라이트의 차례',
    darkTurn: '다크의 차례',
    yourTurn: '당신의 차례',
    opponentTurn: '상대의 차례',
    aiThinking: 'AI 생각 중...',

    // Selection states
    selecting: '{piece} 선택 중',
    observing: '{piece} 관찰 중',
    selectingZombified: '좀비화된 적 {piece} 선택 중',
    selectionLocked: '{piece}에 선택 잠금',
    selectionLockedPenguin: '펭귄이 선택 잠금되었습니다',

    // Hints
    clickToFaint: '{piece}을 클릭하여 기절시키기',
    clickToRotate: '{piece}을 클릭하여 회전시키기',
    clickToInk: '{piece}을 클릭하여 먹물 뿌리기',
    zombifiedWarning: '⚠️ 좀비화 상태에서 {piece}은 이동 전에 회전합니다!',

    // Monkey bonus turn
    monkeySwing: '원숭이가 스윙을 완료했습니다. 보너스 턴을 완료하려면 원숭이를 이동하세요',
    monkeyConsume: '원숭이가 버섯을 먹었습니다. 보너스 턴을 완료하려면 원숭이를 이동하세요',

    // Virus bonus turn
    virusInfecting: '바이러스가 감염 중입니다. 턴을 계속하거나 바이러스를 클릭하여 턴을 종료하세요',

    // Penguin bonus turn
    penguinRotate: '펭귄이 슬라이드를 완료했습니다 - 최종 회전 방향을 선택하세요',
    penguinCaptureRotate: '펭귄이 포획을 완료했습니다 - 최종 회전 방향을 선택하세요',
    penguinZombified: '좀비화된 펭귄이 회전했습니다 - 슬라이드/포획으로 턴 완료 (좀비화가 종료됩니다)',

    // Capture restrictions
    cannotCapture: '{piece}이 포획할 수 없음: {targets}',
    cannotInfect: '{piece}이 감염시킬 수 없음: {targets}',
    cannotEntangle: '{piece}이 얽히게 할 수 없음: {targets}',
    monkeyBearRoll: '{piece}이 적 {target}을 포획하려면 5-6을 굴려야 합니다',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: '곰',
    Crane: '학',
    Frog: '개구리',
    Fungi: '버섯',
    Goat: '염소',
    Monkey: '원숭이',
    Octopus: '문어',
    Penguin: '펭귄',
    Rhino: '코뿔소',
    Snake: '뱀',
    Tree: '나무',
    Virus: '바이러스',
    Wolf: '늑대',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: '이동 컨텍스트',
    emptyState: '자세한 정보를 보려면 왼쪽 패널에서 능력을 선택하세요.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI 아레나',
    tagline: '대결할 AI를 선택하거나 AI끼리 싸우는 것을 관전하세요!',

    // Player labels
    lightPlayer: '라이트 플레이어',
    darkPlayer: '다크 플레이어',
    humanPlayer: '인간 플레이어',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: '센티넬',
    aiAlchemist: '연금술사',
    aiZenith: '제니스',
    aiTrapper: '트래퍼',
    aiHunter: '헌터',
    aiWisp: '위습',
    aiCreature: 'Creature',
    aiWeaver: '위버',

    // Time Frames
    timeFast: '빠름',
    timeStandard: '표준',
    timeDeep: '깊은 사고',

    // Thinking time
    thinkingTime: '사고 시간',

    // Info box
    matchupLabel: '대결:',
    statusLabel: '상태:',
    statusPaused: '일시정지',
    statusAIThinking: 'AI 생각 중...',
    statusInGame: '게임 중',
    statusReady: '준비 완료',
    matchupLocal2P: '로컬 2P',
    matchupPlayerVs: '플레이어 vs',
    matchupVsPlayer: 'vs 플레이어',

    // Buttons
    startButton: '시작',
    startRandomButton: '랜덤 시작',
    newGameButton: '새 게임',
    resumeButton: '재개',
    pauseButton: '일시정지',
    pauseQueuedButton: '일시정지 (대기 중...)',
    viewKingsButton: '킹 보기',
    hideKingsButton: '킹 숨기기',
    viewKingsQueuedButton: '킹 보기 (대기 중...)',
    hideKingsQueuedButton: '킹 숨기기 (대기 중...)',
    homeButton: '홈',
    toggleKingVisibility: '킹 표시 전환',

    // Warning modal
    invalidPlacement: '잘못된 배치',
    okButton: '확인',
    warningLightTurn: '라이트 플레이어가 말을 배치할 차례입니다!',
    warningDarkTurn: '다크 플레이어가 말을 배치할 차례입니다!',
    warningLightRow: '라이트 말은 행 0(홈 행)에 배치해야 합니다!',
    warningDarkRow: '다크 말은 행 7(홈 행)에 배치해야 합니다!',
    warningOccupied: '이 칸은 이미 사용 중입니다! 빈 칸을 선택하세요.',
    warningKingRequired: '5번째 말을 배치하기 전에 킹({kingType})을 배치해야 합니다!',

    // Piece selection
    dragPieces: '말을 보드로 드래그하세요',
    lightPieces: '라이트 말',
    darkPieces: '다크 말',

    // Mobile
    selectYourKing: '킹 선택',
    selectPieceToPlace: '배치할 말 선택',
    moveHistory: '이동 기록',
    historyButton: '기록',
    backButton: '뒤로',
    lightTurn: '라이트의 차례',
    darkTurn: '다크의 차례',
  },

  // Donation
  donation: {
    title: 'Zodiac Chess 후원하기',
    supportDevelopment: '개발 지원',
    story1: '안녕하세요! 여러분의 후원이 이 독특한 게임을 계속 개선하는 데 도움이 됩니다! 새로운 기능 추가, 서버 유지, 그리고 커뮤니티를 위해 Zodiac Chess를 무료로 유지합니다.',
    story2: '작은 기부라도 큰 차이를 만들고 이 프로젝트를 유지합니다. Zodiac Chess 여정의 일원이 되어 주셔서 감사합니다 :)',
    selectAmount: '금액 선택',
    customAmount: '또는 직접 금액 입력:',
    total: '합계:',
    donateButton: '지금 기부하기',
    processing: '처리 중...',
    disclaimer: '기부금은 개발과 서버 비용을 지원합니다. 관대함에 감사드립니다!',
    invalidAmount: '0원보다 큰 유효한 금액을 입력하세요',
    error: '기부 처리 중 오류가 발생했습니다. 다시 시도해 주세요.',
  },

  // Game End Popup
  gameEnd: {
    victory: '승리!',
    defeat: '패배!',
    draw: '무승부!',
    wonBy: '{condition}(으)로 승리',
    lostBy: '{condition}(으)로 패배',
    drawBy: '{condition}(으)로 무승부',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: '킹 처치',
      race: '레이스 승리',
      timeout: '시간 초과',
      threefold: '3회 반복',
      noMoves: '유효한 수 없음',
      draw: '무승부',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: '프리미엄으로 업그레이드',
    accountRequired: '프리미엄으로 업그레이드하기 전에 영구 계정을 만들어야 합니다.',
    createAccountPrompt: '계정을 만들어 진행 상황을 저장하고 프리미엄 기능을 잠금 해제하세요!',
    subtitle: 'Zodiac Chess 경험을 향상시키는 강력한 기능을 잠금 해제하세요!',
    features: {
      history: '계정 기록',
      historyItem1: '이전 게임을 모두 저장하고 불러오기',
      historyItem2: '전략을 평가하기 위해 이전 게임을 언제든지 다시 플레이',
      historyItem3: '깊은 분석을 사용하여 보드 위치와 훌륭한 수의 기회 분석',
      analytics: '분석',
      analyticsItem1: '게임 통계에 액세스',
      analyticsItem2: '다양한 지표에 걸쳐 사용자의 말과 킹 선택 분석',
      analyticsItem3: '어떤 메타가 인기 있고 무엇이 효과적인지 알아보세요!',
      course: '코스',
      courseItem1: '스킬을 개발하기 위한 최신 코스에 액세스',
      courseItem2: '프로에게서 메타와 개념을 배우세요',
      courseItem3: '자신의 약점을 분석하기 위한 게임플레이 팁 얻기',
    },
    createAccount: '계정 만들기',
    upgradeNow: '지금 업그레이드',
    cancel: '취소',
  },

  // Premium Modal
  premium: {
    title: '프리미엄 기능',
    accessDenied: '죄송합니다. 프리미엄 계정이 없어서 아직 이 기능에 액세스할 수 없습니다!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: '오류가 발생했습니다',
    errorMessage: '결제 처리 중 문제가 발생했습니다. 걱정하지 마세요, 청구되지 않았습니다.',
    whatHappened: '무슨 일이 있었나요?',
    notCompleted: '결제가 완료되지 않았습니다. 원인은 다음과 같을 수 있습니다:',
    reasons: {
      cancelled: '결제가 취소됨',
      declined: '카드가 거부됨',
      connection: '결제 중 연결 문제',
      expired: '세션 만료',
    },
    whatToDo: '어떻게 해야 하나요?',
    actions: {
      tryDifferentCard: '다른 카드로 다시 시도',
      tryDifferentCardDesc: '다른 결제 수단을 사용하세요',
      retryPayment: '결제 재시도',
      retryPaymentDesc: '단순한 재시도로 해결되기도 합니다',
      checkBank: '은행에 확인',
      checkBankDesc: '카드에 잔액이 충분한지 확인하세요',
    },
    tryAgain: '업그레이드 다시 시도',
    returnHome: '메인 페이지로 돌아가기',
    contactSupport: '도움이 필요하신가요? support@zodiac-chess.com으로 문의하세요',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
